<template>
  <div class="main">
    <report-top> </report-top>
    <selectTool ref="selectTool"><template slot="btn"><Button @click="getSearchItem" type="error"
          class="chaxun">查询</Button><Button @click="openAdd" type="primary" class="chaxun">新增</Button></template>
    </selectTool>
    <Table border :columns="columns" :data="tableData" no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(200)">
      <template slot-scope="{ row, index }" slot="action">
        <Button size="small" @click="copy(row, index)">复制</Button>
        <Button size="small" @click="opemUpdate(row, index)">编辑</Button>
        <Button size="small" @click="del(row, 1)">删除</Button>
      </template>
    </Table>
    <div id="mypage">
      <div>
        <Page :current="1" :total="total" :page-size="searchItem.pageSize" :page-size-opts="[10, 50, 100]" show-total
          show-elevator show-sizer @on-change="changePage" @on-page-size-change="pageSizeChange"></Page>
      </div>
    </div>
    <form-model :overAuto="true" :title="isAdd ? '新增报价信息' : '编辑报价信息'" ref="formModel" :labelWidth="100" fullscreen>
      <baojia v-if="openBaojia" style="margin-bottom: 20px" slot="endcontent" ref="baojia"></baojia>
      <Button slot="btn" type="primary" @click="addUpdate">提交表单</Button>
    </form-model>
  </div>
</template>
<script>
import baojia from "./baojia";
var kehuitems = [];
export default {
  components: { baojia },
  data() {
    return {
      isAdd: false,
      openBaojia: false,
      columns: [
        {
          type: "index",
          sort: 0,
        },
        {
          title: "创建人",
          key: "creator",
          sort: 7,
        },
        {
          title: "操作",
          slot: "action",
          sort: 25,
          width: 150,
        },
      ],
      tableData: [],
      total: 0,
      searchItem: {
        startTime: "",
        endTime: "",
        pageNumber: 1,
        pageSize: 50,
      },
      searchForms: [
        {
          title: "时间范围",
          key: "startTime",
          key1: "endTime",
          required: true,
          val: 0,
          type: "lyyymmdd",
          times: "4,2,0",
        },
        {
          title: "模板名称",
          key: "name",
          type: "Input",
        },
      ],
      item: {
        content: "",
        name: "",
        remark: "",
        sort: 0,
      },
      forms: [
        {
          title: "模板名称",
          key: "name",
          type: "Input",
          required: true,
          span: 8,
        },
        {
          title: "排序",
          key: "sort",
          type: "InputNumber",
          span: 8,
        },
        {
          title: "备注信息",
          key: "remark",
          type: "Input",
          span: 8,
        },
      ],
    };
  },
  methods: {
    getList() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-tms-server-smm/priceTemplet/list",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        this.tableData = data;
        console.log(data);
      });
    },
    addUpdate(name) {
      var a = this.$refs.formModel.getItem();
      if (!a) {
        return;
      }
      this.item.content = this.$refs.baojia.getVal();
      console.log(this.item);
      this.utils.loading(this, "提交中");
      if (this.isAdd) {
        this.$Spin.hide(); //关闭加载
        this.axios({
          method: "post",
          url: this.axios.ipPort + "/cloud-tms-server-smm/priceTemplet/add",
          data: this.item,
        }).then((res) => {
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      } else {
        this.axios({
          method: "post",
          url: this.axios.ipPort + "/cloud-tms-server-smm/priceTemplet/update",
          data: this.item,
        }).then((res) => {
          this.$Spin.hide(); //关闭加载
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      }
    },
    opemUpdate(row) {
      this.isAdd = false;
      for (const i in this.item) {
        this.item[i] = row[i];
      }
      this.item.id = row.id;
      this.$refs.formModel.reach(this.forms, this.item);
      this.openBaojia = true;
      setTimeout(() => {
        this.$refs.baojia.reach(this.item.content);
      }, 200);
    },
    copy(row) {
      this.isAdd = true;
      for (const i in this.item) {
        this.item[i] = row[i];
      }
      this.$refs.formModel.reach(this.forms, this.item);
      this.openBaojia = true;
      setTimeout(() => {
        this.$refs.baojia.reach(this.item.content);
      }, 200);
    },
    openAdd() {
      this.isAdd = true;
      this.$refs.formModel.reach(this.forms, this.item);
      this.openBaojia = true;
      setTimeout(() => {
        this.$refs.baojia.reach(this.item.content);
      }, 200);
    },
    del(row, n) {
      this.$Modal.confirm({
        title: "删除后数据无法恢复，确定要删除？",
        //content: "退出系统后需要重新登录",
        onOk: () => {
          this.axios({
            method: "post",
            url: this.axios.ipPort + "/cloud-tms-server-smm/priceTemplet/del",
            data: { idList: [row.id] },
          }).then((res) => {
            if (res) {
              this.getList();
            }
          });
        },
      });
    },
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    getSearchItem() {
      this.searchItem = this.$refs.selectTool.getItem();
      this.getList();
    },
  },
  mounted() {
    this.columns = this.utils.cols(this.forms, this.columns);
    this.$refs.selectTool.reach(this.searchForms, this.searchItem);
    setTimeout(() => {
      this.getSearchItem();
    }, 200);
  },
};
</script>
<style></style>


// WEBPACK FOOTER //
// src/components/wuliu/kehu/baojiamuban.vue